var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox points-operate-page" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.detailLoading,
              expression: "detailLoading",
            },
          ],
          staticClass: "box-card",
          attrs: { shadow: "never" },
        },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-steps",
                {
                  staticClass: "operate-steps",
                  attrs: {
                    active: _vm.currentStep,
                    "align-center": "",
                    "finish-status": "success",
                  },
                },
                [
                  _c("el-step", { attrs: { title: "添加返积分活动" } }),
                  _vm._v(" "),
                  _c("el-step", { attrs: { title: "返积分规则" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "step-body" },
            [
              _c(
                "el-form",
                {
                  ref: "baseForm",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-width": "92px",
                    size: "small",
                    disabled: _vm.isView,
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentStep === 0,
                          expression: "currentStep === 0",
                        },
                      ],
                      staticClass: "step-panel step-one",
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "活动名称:",
                            prop: "activityName",
                            required: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "w-220",
                            attrs: {
                              maxlength: "50",
                              placeholder: "请输入活动名称",
                            },
                            model: {
                              value: _vm.formData.activityName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品类型:",
                            prop: "goodsType",
                            required: "",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-220",
                              attrs: {
                                placeholder: "请选择",
                                disabled: _vm.mode === "edit",
                              },
                              model: {
                                value: _vm.formData.goodsType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "goodsType", $$v)
                                },
                                expression: "formData.goodsType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "普通商品", value: "1" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动时间:", prop: "activityTime" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "activity-datetime-range",
                            attrs: {
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "default-time": _vm.activityTimeDefaultRange,
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              disabled: _vm.mode === "edit",
                              "picker-options": _vm.activityTimePickerOptions,
                            },
                            on: {
                              "visible-change": _vm.onActivityTimePickerVisible,
                              change: _vm.onActivityTimeChange,
                            },
                            model: {
                              value: _vm.formData.activityTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "activityTime", $$v)
                              },
                              expression: "formData.activityTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentStep === 1,
                          expression: "currentStep === 1",
                        },
                      ],
                      staticClass: "step-panel step-two",
                    },
                    [
                      _vm.currentStep === 1
                        ? _c(
                            "div",
                            { staticClass: "rule-line rule-line-cash" },
                            [
                              _c("span", { staticClass: "require-mark" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "rule-line-cash-desc" },
                                [
                                  _vm._v(
                                    "用户使用现金消费任意金额，将获得对应支付方式支付金额的"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "cash-point-rate-item",
                                  attrs: {
                                    prop: "cashPointRate",
                                    label: "",
                                    "label-width": "0",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "cash-point-rate-control" },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "num-input",
                                        attrs: {
                                          min: 0,
                                          max: 100000,
                                          precision: 0,
                                          step: 1,
                                          "step-strictly": "",
                                          controls: false,
                                          placeholder: "请输入",
                                        },
                                        model: {
                                          value: _vm.formData.cashPointRate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "cashPointRate",
                                              $$v
                                            )
                                          },
                                          expression: "formData.cashPointRate",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("% 的积分")]),
                                      _vm._v(" "),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _vm._v(
                                                "积分计算基数为商品支付金额,包含现金支付和福豆支付,各自计算其比例"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question tip-icon",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.formData.cardRuleList, function (rule, index) {
                        return _c(
                          "div",
                          {
                            key: "card-rule-" + index,
                            staticClass: "rule-line rule-line-card",
                          },
                          [
                            _c("span", { staticClass: "rule-line-card-text" }, [
                              _vm._v(_vm._s(_vm.cardRuleLeadLabel(rule))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "card-select",
                                attrs: {
                                  multiple: "",
                                  placeholder: "请选择（可多选）",
                                  filterable: "",
                                  remote: "",
                                  clearable: "",
                                  "remote-method": _vm.searchCardOptions,
                                  loading: _vm.cardLoading,
                                },
                                on: { change: _vm.handleCardChange },
                                model: {
                                  value: rule.cardTypes,
                                  callback: function ($$v) {
                                    _vm.$set(rule, "cardTypes", $$v)
                                  },
                                  expression: "rule.cardTypes",
                                },
                              },
                              _vm._l(
                                _vm.getCardOptionsForRow(index),
                                function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: _vm.cardOptionLabel(item),
                                      value: item.id,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "rule-line-card-text" }, [
                              _vm._v(
                                "消费任意金额，将获得对应支付方式支付金额的"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-input-number", {
                              staticClass: "num-input",
                              attrs: {
                                min: 0,
                                max: 100000,
                                precision: 0,
                                step: 1,
                                "step-strictly": "",
                                controls: false,
                                placeholder: "请输入",
                              },
                              model: {
                                value: rule.cardPointRate,
                                callback: function ($$v) {
                                  _vm.$set(rule, "cardPointRate", $$v)
                                },
                                expression: "rule.cardPointRate",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "rule-line-card-text" }, [
                              _vm._v("% 的积分"),
                            ]),
                            _vm._v(" "),
                            !_vm.isView
                              ? _c("i", {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: _vm.pointsOperatePerms,
                                      expression: "pointsOperatePerms",
                                    },
                                  ],
                                  staticClass:
                                    "el-icon-circle-plus-outline add-icon",
                                  on: { click: _vm.addCardRule },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isView && _vm.formData.cardRuleList.length > 1
                              ? _c("i", {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: _vm.pointsOperatePerms,
                                      expression: "pointsOperatePerms",
                                    },
                                  ],
                                  staticClass:
                                    "el-icon-remove-outline remove-icon",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeCardRule(index)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "customer-item",
                          attrs: {
                            label: "适用分销客户:",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled: _vm.isView || _vm.mode === "edit",
                                size: "small",
                              },
                              on: { change: _vm.onApplyCustomerTypeChange },
                              model: {
                                value: _vm.formData.applyCustomerType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "applyCustomerType",
                                    $$v
                                  )
                                },
                                expression: "formData.applyCustomerType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("全部"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("部分"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formData.applyCustomerType === 1,
                              expression: "formData.applyCustomerType === 1",
                            },
                          ],
                          staticClass: "customer-item customer-select-item",
                          attrs: {
                            label: "",
                            "label-width": "120px",
                            required: _vm.formData.applyCustomerType === 1,
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-220",
                              attrs: {
                                multiple: "",
                                filterable: "",
                                remote: "",
                                clearable: "",
                                disabled: _vm.mode === "edit",
                                "remote-method": _vm.searchCustomerOptions,
                                loading: _vm.customerLoading,
                                placeholder: "请选择适用分销客户",
                              },
                              model: {
                                value: _vm.formData.customerScope,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "customerScope", $$v)
                                },
                                expression: "formData.customerScope",
                              },
                            },
                            _vm._l(_vm.customerOptions, function (item) {
                              return _c("el-option", {
                                key: item.customerId,
                                attrs: {
                                  label: item.appName,
                                  value: item.customerId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary", plain: "" },
                  on: { click: _vm.handleReset },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.currentStep > 0
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.prevStep },
                    },
                    [_vm._v("上一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep < 1
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.nextStep },
                    },
                    [_vm._v("下一步")]
                  )
                : !_vm.isView
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: _vm.pointsOperatePerms,
                          expression: "pointsOperatePerms",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.submitLoading,
                      },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("\n        提交\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }